import { ClientRequestData } from "../ClientRequestData";
import { ScheduleConfiguration } from "@/model/data/scheduleSettings/ScheduleConfiguration";

export class SaveInstallationsScheduleConfigurationRequestData extends ClientRequestData {
  installationNameList: string[] = null;
  scheduleConfiguration: ScheduleConfiguration;

  constructor() {
    super();
  }
}
